import { useTagsStore } from '@/feature/tags/store'

import { ModalOpenVariant } from '../TableHeaderTags/TableHeaderTags.types'
import { TagsOverviewPanel } from '../TagsOverviewPanel/TagsOverviewPanel'

export const TagsModalContainer = () => {
  const { isModalOpen, modalVariant } = useTagsStore()

  if (!isModalOpen) return null

  // Render the appropriate modal based on the variant
  if (modalVariant === ModalOpenVariant.ASSET) {
    return <TagsOverviewPanel />
  }

  // For other modal variants, you can add more conditions here
  // Possibly the create and delete tag modals
  return null
}
